module.exports = __webpack_public_path__ + "img/banner-js.1312c9f1.png";